import { COMPANY_FIELD } from '../type_name'
import {mapGetters} from "vuex";
const invalidValue = [ undefined, null, '']
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: COMPANY_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        }
    },
    computed: {
        ...mapGetters({
            companies_hash: 'async/companies_hash',
          }),
        valueHandle() {
            if (invalidValue.includes(this.value) && !invalidValue.includes(this.header.default_value)) {
                return this.header.default_value
            }
            const {company_key = 'short_name'} = this.header
            const companies_hash = this.companies_hash || {}
            return companies_hash[this.value] && companies_hash[this.value][company_key]
        }
    },
    render() {
        return <span>{this.valueHandle}</span> 
    }
}